import { render, staticRenderFns } from "./CarterClinicalTargetPercentage.vue?vue&type=template&id=532376fc&"
import script from "./CarterClinicalTargetPercentage.vue?vue&type=script&lang=ts&"
export * from "./CarterClinicalTargetPercentage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports